export const SET_LOADING = 'SET_LOADING';

export const setLoading = status => ({
  type: SET_LOADING,
  status
});
